// components/providers/providers.tsx
"use client";

import { SessionProvider } from "next-auth/react";
import { Session } from "next-auth";
import { MessagingLayout } from "@/components/messaging/MessagingLayout";
import { Toaster } from "sonner";
import { FirstTimeUserExperience } from "@/components/tour/first-time-user-experience";
import { AnalyticsProvider } from "@/components/providers/analytics-provider";

export default function Providers({
  children,
  session
}: {
  children: React.ReactNode;
  session: Session | null;
}) {
  return (
    <SessionProvider
      session={session}
      refetchInterval={5 * 60} // Refetch session every 5 minutes
      refetchOnWindowFocus={true} // Refetch when window regains focus
    >
      <AnalyticsProvider>
        <MessagingLayout>
          {children}
        </MessagingLayout>
      </AnalyticsProvider>
      <Toaster />
      {/* First-time user experience handles both terms acceptance and tours (mobile/desktop) */}
      <FirstTimeUserExperience />
    </SessionProvider>
  );
}
